module.exports = __webpack_public_path__ + "assets/images/teacher-icon.68a100ab0204b02d5a0f56f933baab86.svg";